const USVirginIsland = () => {
  return (
    <svg
      width="19px"
      height="19px"
      viewBox="0 0 7086 7086"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinecap: "square",
        strokeLinejoin: "bevel",
      }}
      fill="var(--primary-90)"
      color="var(--primary-90)"
      stroke="var(--primary-90)"
    >
      <g>
        <g transform="matrix(0.999913,0,0,0.999913,0,0)">
          <path
            d="M-2,-2L7089,-2L7089,7089L-2,7089L-2,-2"
            style={{ fill: "var(--primary-90)", fillOpacity: 0 }}
          />
        </g>
        <g transform="matrix(0.514085,0,0,0.584456,1757.33,2263.72)">
          <rect x="0" y="0" width="7087" height="5892" style={{ fillOpacity: 0 }} />
        </g>
        <g transform="matrix(0.999913,0,0,0.999913,2857.78,4789.08)">
          <path
            d="M2429.78,311.676L2243.1,331.772L2087.63,382.783L1782.88,523.748L1625.64,572.898L136.034,786.474L0,834.687L53,704.571L61.834,594.226L54.178,283.851L76.262,188.004L135.446,127.4L408.692,211.193L562.394,140.696L721.395,38.654L893.941,0L911.902,19.791L1189.57,207.792L1342.09,261.59L1419.23,302.401L1486.37,363.615L1651.85,226.034L1911.84,169.452L2195.4,184.912L2429.78,259.735L2429.78,311.676"
            style={{ stroke: "var(--primary-90)", strokeWidth: "23.62px" }}
          />
        </g>
        <g transform="matrix(0.999913,0,0,0.999913,1840.13,2322.46)">
          <path
            d="M1229.14,548.744L1177.02,626.357L947.926,540.094L865.715,488.284L800.769,358.723L770.455,427.823L701.256,380.344L545.607,410.677L433.097,389.156L346.42,294.122L117.116,363.482L0,251.168L214.358,137.261L396.915,89.791L662.06,99.47L770.766,177.502L835.608,155.897L718.152,64.812L661.871,0L817.622,47.499L1085.86,203.057L1349.64,354.308L1457.5,526.896L1375.52,539.911L1311.09,518.498L1229.14,548.744"
            style={{ stroke: "var(--primary-90)", strokeWidth: "23.62px" }}
          />
        </g>
        <g transform="matrix(0.999913,0,0,0.999913,3523.86,2344.9)">
          <path
            d="M725.742,233.411L673.879,254.994L751.579,358.709L703.95,535.778L470.756,410.444L107.951,444.985L0,345.651L107.963,181.6L228.929,129.626L358.551,90.741L328.324,34.565L393.147,0L635.107,64.863L751.769,86.511L859.768,134.094L989.376,203.289L1019.56,281.081L920.135,298.312L725.742,233.411"
            style={{ stroke: "var(--primary-90)", strokeWidth: "23.62px" }}
          />
        </g>
      </g>
    </svg>
  );
};

export default USVirginIsland;
